import { useContext } from "react";

import { LeftPanelContext } from "../contexts/LeftPanelContext";

export function useLeftPanel() {
  const context = useContext(LeftPanelContext);

  return context;
}
